import { render, staticRenderFns } from "./CardColorList.vue?vue&type=template&id=4cc8dd92"
import script from "./CardColorList.vue?vue&type=script&lang=js"
export * from "./CardColorList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports